module.exports = __webpack_public_path__ + "img/Path 21 Copy@3x.48c76fca.png";